module.exports = __webpack_public_path__ + "static/media/purewatt-gb-1.8fcc9481.jpg";